// extracted by mini-css-extract-plugin
module.exports = {"table":"AdditionalContracts_table__2DiFr","tooltip__popper":"AdditionalContracts_tooltip__popper__a9Ujd","tooltip__root":"AdditionalContracts_tooltip__root__2wU5g"};